import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import EventHome from "@/pages/EventHome";
import Classifica from "@/pages/Classifica";
import Iscritti from "@/pages/Iscritti";
import Contatti from "@/pages/Contatti";
import Dettagli from "@/pages/Dettagli";
import GlobalRanking from "@/pages/GlobalRanking";
import Admin from "@/pages/Admin";
import AdminGames from "@/pages/AdminGames";
import AdminFinals from "@/pages/AdminFinals";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="app-shell">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/event" element={<EventHome />} />
            <Route path="/event/classifica" element={<Classifica />} />
            <Route path="/event/iscritti" element={<Iscritti />} />
            <Route path="/event/contatti" element={<Contatti />} />
            <Route path="/event/dettagli" element={<Dettagli />} />
            <Route path="/ranking" element={<GlobalRanking />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/games" element={<AdminGames />} />
            <Route path="/admin/finals" element={<AdminFinals />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
